var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconoPersonaQueFirma = function SvgIconoPersonaQueFirma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icono-persona-que-firma_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.691 47.623H1V12.095L12.965 0h24.726v47.623Z",
    fill: "#D3122D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.655.414v12.54H5.2",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.242 6.998v46.235H7.922",
    stroke: "#E8183B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.393 36.056 12.769-13-3.799-3.87-8.651 8.807-5.065-5.167-4.118 4.193 8.864 9.037Z",
    fill: "#fff",
    stroke: "#E8183B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icono-persona-que-firma_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1)",
    d: "M0 0h43v54H0z"
  })))));
};
export default SvgIconoPersonaQueFirma;